import './index.scss';
import React from 'react';
import { getBooleanValue, getPageQuery } from '../../utils';
import DrawerWrapper from '@/components/drawerWrapper';
import { Icon, NavBar } from 'antd-mobile';
import { Resource } from '../../components/studio/list';

function ResMore() {
  const { sourceId, sourceModule, resType, sourceApp } = getPageQuery();

  return (
    <DrawerWrapper>
      <div className={`studioResMore${getBooleanValue('IS_IMMERSE', false) ? ' immerse' : ''}`}>
        <NavBar
          mode="light"
          icon={<Icon type="left" />}
          onLeftClick={() => window.history.go(-1)}
        >
          <span>名师资源</span>
        </NavBar>
        <div className="content">
          <Resource
            className="resMoreModel"
            studioId={sourceId}
            sourceModule={sourceModule}
            resTypeId={resType}
            sourceApp={sourceApp}
            resMore
          />
        </div>
      </div>
    </DrawerWrapper>
  );
}

export default ResMore;
